import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ChartTypeOption {
  id: string;
  label: string;
}

@Component({
  selector: 'app-br-chart-type-toggle',
  templateUrl: './chart-type-toggle.component.html'
})
export class BrChartTypeToggleComponent {
  @Input() options: ChartTypeOption[] = [];
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  select(option: ChartTypeOption) {
    this.valueChange.emit(option.id);
  }
}
